import {ClickerGameLayers} from '../../ClickerGame.constants';
import {Container} from 'pixi.js';

import {PixiViewComponent} from '@/gcs/PixiViewComponent';

export class EmittersContainerViewComponent extends PixiViewComponent {
  public renderView(): Container {
    const container = new Container();
    container.zIndex = ClickerGameLayers.EmittersPoolLayer;
    return container;
  }
}
